import { useState } from 'react'
import {
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Snackbar,
} from '@mui/material'
import {
  FileDownload,
  TableChart,
  Description,
  PictureAsPdf,
} from '@mui/icons-material'

const EXPORT_OPTIONS = [
  { key: 'excel', label: 'Export to Excel', icon: TableChart },
  { key: 'csv', label: 'Export to CSV', icon: Description },
  { key: 'pdf', label: 'Export to PDF', icon: PictureAsPdf },
]

export default function ExportMenu() {
  const [anchorEl, setAnchorEl] = useState(null)
  const [snackbar, setSnackbar] = useState({ open: false, message: '' })

  const handleExport = (option) => {
    setAnchorEl(null)
    setSnackbar({ open: true, message: `${option.label} started` })
  }

  return (
    <>
      <Button
        variant="outlined"
        startIcon={<FileDownload />}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        size="small"
      >
        Export
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {EXPORT_OPTIONS.map((opt) => (
          <MenuItem key={opt.key} onClick={() => handleExport(opt)}>
            <ListItemIcon><opt.icon fontSize="small" /></ListItemIcon>
            <ListItemText>{opt.label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ open: false, message: '' })}
        message={snackbar.message}
      />
    </>
  )
}
